// SIWS CUSTOM (2026-10-08): Plop & Print product page — plop-print-picker.js
// Size x Tier variants. Total pieces (all sizes, this product only) picks the
// tier; every size is added at that tier's variant. Minimum = lowest tier start.
// Business Name + Phone Number required, sent on every line. If this product is
// already in the cart, the page pre-fills from it and replaces those lines.

(function () {
  function parseTier(label) {
    var s = String(label || '').replace(/\s+/g, '').replace(/–|—/g, '-');
    var m = s.match(/^(\d+)(?:-(\d+)|\+)$/);
    if (!m) return null;
    return { label: label, min: parseInt(m[1], 10), max: m[2] ? parseInt(m[2], 10) : Infinity };
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function formatPhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length !== 10) return String(raw || '').trim();
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  window.SiwsPlopPrint = { parseTier: parseTier };

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('siws-pp-form');
    var dataEl = document.getElementById('siws-pp-data');
    if (!form || !dataEl) return;
    var data = JSON.parse(dataEl.textContent);

    // Sizes in variant order; tiers sorted by their starting quantity.
    var sizes = [], tierLabels = [];
    data.variants.forEach(function (v) {
      if (sizes.indexOf(v.size) === -1) sizes.push(v.size);
      if (tierLabels.indexOf(v.tier) === -1) tierLabels.push(v.tier);
    });
    var tiers = tierLabels.map(parseTier).filter(Boolean).sort(function (a, b) { return a.min - b.min; });
    if (!tiers.length) return;
    var MIN = tiers[0].min;
    var byKey = {};
    data.variants.forEach(function (v) { byKey[v.size + '|' + v.tier] = v; });
    var baseSize = sizes[0];

    var subEl = form.querySelector('[data-pp-sub]');
    var tiersEl = form.querySelector('[data-pp-tiers]');
    var upEl = form.querySelector('[data-pp-upcharge]');
    var sizesEl = form.querySelector('[data-pp-sizes]');
    var statusEl = form.querySelector('[data-pp-status]');
    var summaryEl = form.querySelector('[data-pp-summary]');
    var nameEl = document.getElementById('siws-pp-business');
    var phoneEl = document.getElementById('siws-pp-phone');
    var errorEl = document.getElementById('siws-pp-error');
    var atcBtn = document.getElementById('siws-pp-atc-btn');
    var existingKeys = [];

    subEl.textContent = MIN + '-piece minimum · mix any sizes';

    // Tier table (prices for the base size).
    tiersEl.innerHTML = tiers.map(function (t) {
      var v = byKey[baseSize + '|' + t.label];
      return '<tr data-tier="' + t.label + '"><td>' + (t.max === Infinity ? t.min + '+' : t.min + ' – ' + t.max) +
        ' pieces</td><td>' + (v ? money(v.price) + ' ea' : '') + '</td></tr>';
    }).join('');

    // Upcharge line, derived from the first tier.
    var ups = [];
    sizes.forEach(function (s) {
      var v = byKey[s + '|' + tiers[0].label], b = byKey[baseSize + '|' + tiers[0].label];
      if (v && b && v.price > b.price) {
        var diff = v.price - b.price, last = ups[ups.length - 1];
        if (last && last.diff === diff) last.sizes.push(s); else ups.push({ diff: diff, sizes: [s] });
      }
    });
    upEl.textContent = ups.length ? ups.map(function (u) {
      var label = u.sizes.length > 1 ? u.sizes[0] + '–' + u.sizes[u.sizes.length - 1] : u.sizes[0];
      return label + ' +' + money(u.diff) + ' ea';
    }).join(' · ') : '';

    // Size inputs (ghost zero).
    sizesEl.innerHTML = sizes.map(function (s) {
      return '<label class="siws-pp-size" data-size-box="' + s + '"><span class="siws-pp-size__name">' + s +
        '</span><span class="siws-pp-size__price" data-size-price="' + s + '"></span>' +
        '<input type="number" min="0" step="1" inputmode="numeric" placeholder="0" value="" data-pp-qty="' + s + '" aria-label="' + s + ' quantity"></label>';
    }).join('');
    var inputs = sizesEl.querySelectorAll('[data-pp-qty]');

    function qtyOf(input) { var n = parseInt(input.value, 10); return isNaN(n) || n < 0 ? 0 : n; }
    function total() { var n = 0; inputs.forEach(function (i) { n += qtyOf(i); }); return n; }
    function tierFor(n) { for (var i = tiers.length - 1; i >= 0; i--) if (n >= tiers[i].min) return tiers[i]; return null; }
    function clearError() { errorEl.textContent = ''; errorEl.removeAttribute('data-visible'); }
    function showError(m) { errorEl.textContent = m; errorEl.setAttribute('data-visible', 'true'); }

    function render() {
      var n = total();
      var t = tierFor(n);
      var priceTier = t || tiers[0];

      tiersEl.querySelectorAll('tr').forEach(function (r) {
        r.classList.toggle('is-active', !!t && r.dataset.tier === t.label);
      });
      inputs.forEach(function (i) {
        var s = i.dataset.ppQty, v = byKey[s + '|' + priceTier.label];
        form.querySelector('[data-size-price="' + s + '"]').textContent = v ? money(v.price) : '';
        form.querySelector('[data-size-box="' + s + '"]').classList.toggle('has-qty', qtyOf(i) > 0);
      });

      if (n === 0) {
        statusEl.className = 'siws-pp-status';
        statusEl.textContent = 'Minimum ' + MIN + ' pieces — enter quantities for any mix of sizes.';
      } else if (!t) {
        statusEl.className = 'siws-pp-status';
        statusEl.textContent = n + ' pieces — add ' + (MIN - n) + ' more to reach the ' + MIN + '-piece minimum.';
      } else {
        var next = tiers[tiers.indexOf(t) + 1];
        statusEl.className = 'siws-pp-status is-met';
        statusEl.textContent = '✓ ' + n + ' pieces — ' + (t.max === Infinity ? t.min + '+' : t.min + '–' + t.max) + ' price tier' +
          (next ? ' (add ' + (next.min - n) + ' more for the next price break)' : '');
      }

      var rows = [], sum = 0;
      if (t) {
        inputs.forEach(function (i) {
          var q = qtyOf(i); if (!q) return;
          var v = byKey[i.dataset.ppQty + '|' + t.label]; if (!v) return;
          sum += v.price * q;
          rows.push('<div class="siws-pp-summary__row"><span>' + i.dataset.ppQty + '</span><span>' + q + ' × ' + money(v.price) + ' = ' + money(v.price * q) + '</span></div>');
        });
      }
      if (rows.length) {
        summaryEl.hidden = false;
        summaryEl.innerHTML = rows.join('') + '<div class="siws-pp-summary__row siws-pp-summary__total"><span>Total (' + n + ' pieces)</span><span>' + money(sum) + '</span></div>';
      } else {
        summaryEl.hidden = true; summaryEl.innerHTML = '';
      }

      var verb = existingKeys.length ? 'Update Cart' : 'Add to Cart';
      if (!t) { atcBtn.disabled = true; atcBtn.textContent = n ? 'Add ' + (MIN - n) + ' more to continue' : 'Enter quantities to continue'; }
      else if (!nameEl.value.trim() || !phoneEl.value.trim()) { atcBtn.disabled = true; atcBtn.textContent = 'Enter business name and phone to continue'; }
      else { atcBtn.disabled = false; atcBtn.textContent = verb + ' — ' + n + ' pieces, ' + money(sum); }
    }

    inputs.forEach(function (i) { i.addEventListener('input', function () { clearError(); render(); }); });
    [nameEl, phoneEl].forEach(function (el) { el.addEventListener('input', render); });
    phoneEl.addEventListener('blur', function () { phoneEl.value = formatPhone(phoneEl.value); render(); });

    // Pre-fill from the cart if this product is already there.
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var mine = (cart.items || []).filter(function (it) { return String(it.product_id) === String(data.productId); });
      if (!mine.length) { render(); return; }
      existingKeys = mine.map(function (it) { return it.key; });
      var bySize = {};
      mine.forEach(function (it) {
        var v = data.variants.filter(function (x) { return x.id === it.variant_id; })[0];
        if (v) bySize[v.size] = (bySize[v.size] || 0) + it.quantity;
        var p = it.properties || {};
        if (p['Business Name'] && !nameEl.value) nameEl.value = p['Business Name'];
        if (p['Phone Number'] && !phoneEl.value) phoneEl.value = p['Phone Number'];
      });
      inputs.forEach(function (i) { if (bySize[i.dataset.ppQty]) i.value = String(bySize[i.dataset.ppQty]); });
      render();
    }).catch(render);

    atcBtn.addEventListener('click', function () {
      var n = total(), t = tierFor(n);
      if (atcBtn.disabled || !t) return;
      phoneEl.value = formatPhone(phoneEl.value);
      var props = { 'Business Name': nameEl.value.trim(), 'Phone Number': phoneEl.value.trim() };
      var items = [];
      inputs.forEach(function (i) {
        var q = qtyOf(i); if (!q) return;
        var v = byKey[i.dataset.ppQty + '|' + t.label];
        if (v) items.push({ id: v.id, quantity: q, properties: props });
      });
      if (!items.length) return;

      var original = atcBtn.textContent;
      atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; clearError();

      var cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var clear = existingKeys.length
        ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: existingKeys.reduce(function (o, k) { o[k] = 0; return o; }, {}) }) })
            .then(function (r) { if (!r.ok) throw new Error('clear failed'); })
        : Promise.resolve();

      clear.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items,
            sections: cartUi ? cartUi.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
            sections_url: window.location.pathname }) });
      }).then(async function (res) {
        if (!res.ok) throw new Error('add failed');
        var responseData = await res.json();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-plop-print', cartData: responseData });
        }
        if (cartUi) { cartUi.renderContents(responseData); }
        else {
          var html = responseData.sections && responseData.sections['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        existingKeys = (cart.items || []).filter(function (it) { return String(it.product_id) === String(data.productId); })
          .map(function (it) { return it.key; });
        render();
      }).catch(function () {
        atcBtn.disabled = false; atcBtn.textContent = original;
        showError('Something went wrong — please try again.');
      });
    });
  });
})();
